import { ACTIONS } from '../Constants';
import { buildQueryString } from '../utils/StringUtils';
import { VerbFetch } from '../VerbFetch';

export const getBookmark = (params) => {
    const { id, pathsContext } = params;

    return (dispatch) =>
        VerbFetch(`${pathsContext.serverUrl}/bookmarks/${id}`).then((body) => {
            dispatch({
                type: ACTIONS.GET_BOOKMARK,
                payload: {
                    bookmark: body
                }
            });
            return body;
        });
};

export const postBookmark = (params) => {
    const { body, pathsContext } = params;
    const url = `${pathsContext.serverUrl}/bookmarks`;
    const fetchOptions = {
        method: 'POST',
        body
    };
    return (dispatch) =>
        VerbFetch(url, fetchOptions).then((response) => {
            dispatch({
                type: ACTIONS.POST_BOOKMARK,
                payload: {
                    bookmark: response
                }
            });
            return response;
        });
};

export const putBookmark = (params) => {
    const { id, body, pathsContext } = params;
    const url = `${pathsContext.serverUrl}/bookmarks/${id}`;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return (dispatch) =>
        VerbFetch(url, fetchOptions).then((response) => {
            dispatch({
                type: ACTIONS.PUT_BOOKMARK,
                payload: {
                    bookmark: response
                }
            });
            return response;
        });
};

export const getManyBookmarks = (params) => {
    const { pathsContext, ...rest } = params;
    // get all user's bookmarks or ones relevant to current workspace's UserLearningAsset
    const baseUrl = `${pathsContext.serverUrl}/bookmarks`;
    const url = buildQueryString(rest, baseUrl);
    if (rest && rest.ignoreDispatch) {
        return VerbFetch(url);
    }
    return (dispatch) =>
        VerbFetch(url).then((body) => {
            dispatch({
                type: ACTIONS.GET_MANY_BOOKMARKS,
                payload: {
                    bookmarks: body
                }
            });
            return body;
        });
};
